import { Percomatic } from '@biggby-coffee/percomatic-typescript';

import { OrderModifierInput } from '../../graphql';
import { moneyToCents } from '../moneyToCents';


export const transModifierToOrderModifierInput = (
	input: Percomatic.Serialized.TransModifier
): OrderModifierInput => ({
	id: input.id,
	modifierId: String(input.modifier.id),
	price: moneyToCents(input.price)
});
